import { ofType } from 'redux-observable';
import { timer } from 'rxjs';
import {
	switchMap,
	map,
} from 'rxjs/operators';
import moment from 'moment';
import {
	actionTypes,
	conversationErrorActions,
} from '../../../controller';

const {
	GET_CONVERSATION_SILENCE,
} = actionTypes;
const {
	resetConversationSilenceAction,
} = conversationErrorActions;

export function getConversationSilenceEpic(action$) {
	return action$.pipe(
		ofType(GET_CONVERSATION_SILENCE),
		switchMap(({ blockTo }) => {
			const blockTime = moment(blockTo).diff(moment());

			return timer(blockTime).pipe(
				map(() => resetConversationSilenceAction()),
			);
		}),
	);
}
